export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_INVOICING_ERRORS",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_INVOICING_ERRORS",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_INVOICING_ERRORS",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_INVOICING_ERRORS",
  DESTROY_FORM: "DESTROY_FORM_INVOICING_ERRORS",
  SET_FORM_ERROR: "SET_FORM_ERROR_INVOICING_ERRORS",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_INVOICING_ERRORS",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_INVOICING_ERRORS",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_INVOICING_ERRORS",
  RESET_STATE: "RESET_STATE_INVOICING_ERRORS",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_INVOICING_ERRORS",
  REMOVE_OBJECT: "REMOVE_OBJECT_INDUSTRIAL_INVOICING_ERRORS",
  CLEAR_FETCHED: "CLEAR_FETCHED_INVOICING_ERRORS",

  LIST_URL: "/accounting/basic/billectaouterror/list/",
  POST_URL: "/accounting/basic/billectaouterror/",
  PATCH_URL: "/accounting/basic/billectaouterror/",
  GET_URL: "/accounting/basic/billectaouterror/",

  STORE_NAME: "invoicingErrors",
};
